<template>
  <div class="invoice-statement">
    <h4>喔刷伙伴 2.0 结算单（企业认证版）</h4>
    <p>
      <u>{{ params.referKeyName }}</u>
      {{ params.date || '' }}&nbsp; 发放服务费明细如下：
    </p>
    <table>
      <tr>
        <td><b>结算</b></td>
        <td>{{ params.incomeMoney || 0 | formatMoney }}</td>
      </tr>
      <tr>
        <td><b>补贴</b></td>
        <td>{{ params.actMoney || 0 | formatMoney }}</td>
      </tr>
      <tr>
        <td><b>总计</b></td>
        <td>{{ params.allMoney || 0 | formatMoney }}</td>
      </tr>
    </table>

    <p>请根据合同中开具发票要求，发票信息如下：</p>
    <p><b class="special">开票类型：增值税专用发票</b></p>
    <p><b class="special">开票名目: *信息技术服务*技术服务费</b></p>
    <p>
      <b>开票金额（含税）：￥ {{ params.allMoney || 0 | formatMoney }}</b>
    </p>
    <p><b>开票信息：</b></p>
    <section>
      <p>公司名称：浙江喔刷信息技术有限公司</p>
      <p>税务登记号：91330783MA29QB8M1M</p>
      <p>
        地址:浙江省金华市东阳市六石街道木雕小镇广福东街 1509 号 201 室
        0579-86399130
      </p>
      <p>开户行及账号：中国工商银行股份有限公司东阳支行 1208040009049227841</p>
    </section>
    <section>
      <p class="indent">
        请贵司对以上数据进行核实并确认，如有出入请及时告知。如数据确认无误，请将
        <b class="special">结算单加盖公章</b>
        与
        <b class="special">发票</b>
        一起寄至我司。发票及结算单收到并核对后我司会发放当月服务费。
      </p>
      <p class="indent">
        邮寄地址及联系方式：
        {{ params.addrInfo || '' }}
      </p>
      <p class="indent">
        <b class="special">请勿到付！</b>
        万分感谢！
      </p>
    </section>
    <br />
    <section class="signature">
      <p>浙江喔刷信息技术有限公司</p>
      <p>{{ params.creatDate || '' }}</p>
    </section>
    <hr />
    <br />
    <section>
      <p>浙江喔刷信息技术有限公司：</p>
      <p class="indent">
        我司确认上述结算信息无误，请将以上列明服务费划拨至我司指定账户，
        <u>服务费发放账户为合同签订的账户。</u>
      </p>
    </section>
    <br />
    <br />
    <div class="seal">签字：</div>
  </div>
</template>

<script>
import { WSBridge, formatMoney } from '@/utils/utils'
import { Dialog } from 'vant'
export default {
  filters: {
    formatMoney
  },
  data() {
    return {
      url: this.$route.query.url || '',
      params: this.$route.query.params || ''
    }
  },
  created() {
    SyHybridSdk.setNavigationBarTitle({
      params: {
        title: '结算单'
      },
      success: res => {}
    })
    if (Object.prototype.toString.call(this.params) === '[object String]') {
      this.params = JSON.parse(this.params)
    }
    this.formatName()
    const self = this
    SyHybridSdk.setNavRightBtn({
      params: {
        isShow: 1,
        label: '复制',
        func() {
          self.copy()
        }
      },
      success: res => {}
    })
  },
  methods: {
    formatName() {
      let referKeyName = this.params.referKeyName
      let arr = referKeyName.split(' ')
      arr[1] = arr[1].substring(0, 8)
      this.params.referKeyName = arr.join(' ')
    },
    copy() {
      if (!this.url) {
        alert('暂无结算单')
        return
      }
      let self = this
      this.$copyText(this.url).then(
        e => {
          Dialog.alert({
            title: '提示',
            message: '已复制，打开链接后打印即可',
            confirmButtonText: '去粘贴'
          })
        },
        e => {
          // 针对复制失败的补救办法
          let input = document.createElement('input')
          input.setAttribute('id', 'input_for_copyText')
          input.value = self.url
          document.getElementsByTagName('body')[0].appendChild(input)
          document.getElementById('input_for_copyText').select()
          if (document.execCommand) {
            document.execCommand('copy')
            document.getElementById('input_for_copyText').remove()
            Dialog.alert({
              title: '提示',
              message: '已复制，打开链接后打印即可',
              confirmButtonText: '去粘贴'
            })
          } else {
            Dialog.alert({
              title: '提示',
              message: '复制失败'
            })
          }
        }
      )
    }
  },
  beforeDestroy() {
    SyHybridSdk.setNavRightBtn({
      params: {
        isShow: 0,
        label: '',
        func() {}
      },
      success: res => {}
    })
  }
}
</script>
